import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '首页 | 合肥智己网络科技有限公司'
          }
        }, {
          path: '/software',
          name: 'software',
          component: resolve => require(['@/view/Software'], resolve),
          meta: {
            title: 'APP产品'
          },
          children: [
            {
              path: '/software',
              redirect: '/software/screenTrans'
            },
            {
              path: '/software/globalTrans',
              name: 'software',
              component: resolve => require(['@/view/Software_globalTrans'], resolve),
              meta: {
                title: 'APP产品丨全球语音翻译 | 合肥智己网络科技有限公司'
              }
            },
            {
              path: '/software/screenTrans',
              name: 'software',
              component: resolve => require(['@/view/Software_screenTrans'], resolve),
              meta: {
                title: 'APP产品丨屏幕翻译君 | 合肥智己网络科技有限公司'
              }
            },
            {
              path: '/software/zimuTrans',
              name: 'software',
              component: resolve => require(['@/view/Software_zimuTrans'], resolve),
              meta: {
                title: 'APP产品丨视频翻译器 | 合肥智己网络科技有限公司'
              }
            },
            {
              path: '/software/aiWriting',
              name: 'software',
              component: resolve => require(['@/view/Software_aiWriting'], resolve),
              meta: {
                title: 'APP产品丨AI作文宝 | 合肥智己网络科技有限公司'
              }
            }
          ]
        }, {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: '公司介绍 | 合肥智己网络科技有限公司'
          }
        }, {
          path: '/jobchance',
          name: 'jobchance',
          component: resolve => require(['@/view/JobChance'], resolve),
          meta: {
            title: '工作机会 | 合肥智己网络科技有限公司'
          }
        }, {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '联系我们 | 合肥智己网络科技有限公司'
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js